// Refer to phaser-nineslice-softgames.js
G.Utils.CalcHelper = {};

G.Utils.CalcHelper.angleBetweenPoints = (point1, point2) => {
  const a = point1.dot(point2);
  const b = point1.getMagnitude() * point2.getMagnitude();
  const x = Math.acos(a / b);
  return x * (180 / Math.PI);
};
